import { render, staticRenderFns } from "./courseInfo.vue?vue&type=template&id=13e1606c&scoped=true"
import script from "./courseInfo.vue?vue&type=script&lang=js"
export * from "./courseInfo.vue?vue&type=script&lang=js"
import style0 from "./courseInfo.vue?vue&type=style&index=0&id=13e1606c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e1606c",
  null
  
)

export default component.exports